import { SR_API_ACTION_PARTNER_TOUR_REQUEST_FOLLOW_UP } from 'api/actionTypes';

export default async function partnerTourRequestFollowUp(
  { state, apiClient },
  { partnerTourRequestId, reachedOutByPartner },
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_TOUR_REQUEST_FOLLOW_UP,
    state: state,
    payload: {
      partnerTourRequestId,
      reachedOutByPartner,
    },
  });
}
